import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from '../i18n';

/**
 * Keeps i18n language in sync with the URL path on client-side navigation.
 * The initial language is already set correctly in src/i18n/index.ts.
 * This hook handles subsequent route changes (e.g. /contact → /es/contacto).
 */
export function useLanguageFromPath() {
  const location = useLocation();

  useEffect(() => {
    const targetLang = location.pathname.startsWith('/es') ? 'es' : 'en';
    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang);
    }
  }, [location.pathname]);
}
